<template>
    <div class="card shadow-sm border-0 mb-3">
        <div class="card-header d-flex px-3 py-2">
            <div class="flex-grow-1 d-flex align-items-center">
                <h6 class="d-flex align-items-center border rounded mr-1 mb-0">
                    <span class="badge badge-light">
                        {{ stageTotal }}
                    </span>
                </h6>
                <h6 class="card-title font-noto-serif-tc font-weight-bolder mb-0">
                    {{ title }}
                </h6>
            </div>
            <div class="pr-1">
                <b-spinner small
                           variant="secondary"
                           v-if="isLoading">
                </b-spinner>
            </div>
        </div>
        <ul class="task-list list-group list-group-flush">
            <li class="list-group-item text-center"
                v-if="tasks.length === 0">
                尚未有相關項目
            </li>
            <template v-else>
                <dynamic-scroller key-field="_id"
                                  v-bind:items="tasks"
                                  v-bind:min-item-size="54"
                                  v-on:scroll.native="onScroll">
                    <template v-slot="{ item, index, active }">
                        <dynamic-scroller-item  v-bind:item="item"
                                                v-bind:active="active"
                                                v-bind:size-dependencies="['item.title', 'item.site.address', ]"
                                                v-bind:data-index="index">
                            <list-item v-bind:key="item._id"
                                       v-bind:task="item">
                            </list-item>
                        </dynamic-scroller-item>
                    </template>
                </dynamic-scroller>
            </template>
        </ul>
    </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";

import {
    DynamicScroller,
    DynamicScrollerItem,
} from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

import ListItem from "./ListItem";

export default {
    name: "ListGroup",
    components: {
        BSpinner,
        DynamicScroller,
        DynamicScrollerItem,
        ListItem,
    },
    props: {
        "stage": {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            isLoading: false,
        };
    },
    computed: {
        title () {
            return this.stage ? this.stage.name : "";
        },
        stageId () {
            return this.stage ? this.stage._id : "";
        },
        stageTotal () {
            return this.$store.getters["tasks/getTaskTotal"](this.stageId) ?? [];
        },
        tasks () {
            return this.$store.getters["tasks/getTasks"](this.stageId) ?? [];
        },
    },
    methods: {
        onScroll (evt) {
            if (evt.target.offsetHeight + evt.target.scrollTop >= evt.target.scrollHeight) {
                this.loadMore();
            }
        },
        async loadMore () {
            if (this.isLoading === false) {
                this.isLoading = true;
                try {
                    await this.$store.dispatch(
                        "tasks/getMoreTasksByStage",
                        this.stageId
                    );
                } catch (e) {
                    console.error(e);
                    this.isLoading = false;
                    return;
                }
                this.isLoading = false;
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.task-list {
    max-height: 500px;
}
</style>
